// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#common-modal .ev-modal-container {
  width: 520px;
}
#common-modal .error-modal-message {
  min-height: 96px;
}
#common-modal .error-icon {
  color: var(--danger-color-main);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/CommonModal.scss"],"names":[],"mappings":"AAEE;EACE,YAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAIE;EACE,+BAAA;AAFJ","sourcesContent":["#common-modal {\r\n\r\n  .ev-modal-container {\r\n    width: 520px;\r\n  }\r\n\r\n  .error-modal-message{\r\n    min-height: 96px;\r\n  }\r\n  .error-icon{\r\n    color: var(--danger-color-main)\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
